import { BankService } from "./../../../services/catalogs/BankService";
import { CreateBankDto } from "./../../../dtos/catalogs/bank/CreateBankDto";
import { BankDetail } from "./../../../components/Pages/Catalogs/bank/BankDetail";
import { BankAccountService } from "../../../services/catalogs/BankAccountService";
import React from "react";
import { IAppEntity } from "../../entities";
import { ReferenceTypes } from "../../../enums/ReferenceTypes";
import { NFLookupBank } from "../../../components/Shared/NewForms/NFLookupBank";
import BankList from "../../../components/Pages/Catalogs/bank/BankList";

export const Bank: IAppEntity = {
  entityType: "catalog",
  title: "Bank",
  pluralTitle: "Bank",
  apiUrl: "Banks",
  apiEnum: ReferenceTypes.CatalogBank,
  getDetailViewComponent(
    model: any,
    modelUpdatedEvent: (model: any) => void
  ): any {
    return React.createElement(BankDetail, {
      model: model,
      modelUpdatedEvent: modelUpdatedEvent,
    });
  },
  getListView: (model: any, modelUpdatedEvent: (model: any) => void) =>
    React.createElement(BankList, {
      model: model,
      modelUpdatedEvent: modelUpdatedEvent,
    }),
  getLookupComponent(model: any): any {
    return React.createElement(NFLookupBank, {
      fieldName: model.fieldName,
      title: model.title,
      setSelectedCatalog: model.setSelectedCatalog,
    });
  },
  getDataService() {
    return new BankService(this.apiUrl);
  },
  getEmptyModel(): CreateBankDto {
    return {
      name: "",
      uniqueCode: "",
      bic: "",
      BankAccounts: [],
      createdDate: new Date(),
    };
  },
};
